import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit, inject } from '@angular/core';
import { Route, Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoginDialogComponent } from '@dges/modules/auth/feature';
import { AuthFacade } from '@dges/modules/auth/store/ngrx';
import { Observable } from 'rxjs';
import { User } from '@dges/modules/auth/domain';
import { AsyncPipe } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { LogoComponent } from 'logo';
import { FullLengthMenuComponent } from '@dges/ui/full-length-menu';
import { DropDownMenuComponent } from '@dges/ui/drop-down-menu';
import { LayoutComponent } from '@dges/ui/layout';

@Component({
  selector: 'dges-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    LayoutComponent,
    AsyncPipe,
    RouterLink,
    RouterOutlet,
    MatRipple,
    MatButton,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatIcon,
    LogoComponent,
    FullLengthMenuComponent,
    DropDownMenuComponent
],
})
export class AppComponent implements OnInit {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private authFacade = inject(AuthFacade);
  private breakpointObserver = inject(BreakpointObserver);

  public fillerNav: Route[] = [];
  public user$: Observable<User>;
  public showFullMenu = false;

  constructor() {
    this.fillerNav.push(...this.router.config.filter((route) => route.path));
    this.user$ = this.authFacade.loadUser();

    this.breakpointObserver
      .observe(['(min-width: 850px)'])
      .subscribe((state: BreakpointState) => {
        this.showFullMenu = state.matches;
      });
  }

  ngOnInit(): void {
    this.user$.subscribe();
  }

  openLogin(): void {
    const dialogRef = this.dialog.open(LoginDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.authFacade.login(
          result.emailFormControl,
          result.passwordFormControl,
        );
      }
    });
  }

  logout(): void {
    this.authFacade.logout();
  }
}
